import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'
Vue.use(Router)
/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    hidden: true                 if true, this route will not show in the sidebar (default is false)
  }
  // 设定路由的名字，当使用<keep-alive>时请务必填写，并且应该与引用的 component class 的 name 属性相同, 详细请看：https://vuejs.org/v2/guide/components-dynamic-async.html#keep-alive-with-Dynamic-Components
  name: 'router-name'
  // 当值为 noredirect 的时候该路由在面包屑导航中不可被点击
  redirect: 'noredirect'
  meta: {
    // 设置该路由进入的权限，支持多个权限叠加
    roles: ['admin', 'editor']
    // 设置该路由在侧边栏和面包屑中展示的名字
    title: 'title'
    // 设置该路由侧边栏的图标
    icon: 'svg-name'
    // 当设置 true 的时候该路由不会再侧边栏出现 如 401，login 等页面，或者如一些编辑页面 /edit/1, (默认 false)
    hidden: true
    // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
    // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
    // 若你想不管路由下面的 children 声明的个数，总是显示你的根路由
    // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由 (默认 false)
    alwaysShow: true
    // 如果设置为 false，则不会在面包屑中显示 (默认 true)
    breadcrumb: false
    // 如果设置为 true，则不会被 <keep-alive> 缓存 (默认 false)
    noCache: true
    // 如果设置为 true, 则这个路由会被一直固定在 tags-view 的最前面 (默认 false)
    affix: true
    // 如果设置了值， 则侧边栏会高亮显示设置的值所指向的路由 (默认 空)
    activeMenu: '/example/list'
  }
*/
// export default new Router({
//   // mode: 'history',  // Enable this if you need.
//   scrollBehavior: (to, from, savedPosition) => {
//     if (savedPosition) {
//       return savedPosition
//     } else {
//       return { x: 0, y: 0 }
//     }
//   },
//   base: process.env.BASE_URL,
//   routes: [
//     {
//       path: '/login',
//       component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue'),
//       meta: { title: '用户登录', hidden: true }
//     },
//     // {
//     //   path: '/login',
//     //   component: () => import(/* webpackChunkName: "login" */ '@/views/login/client.vue'),
//     //   meta: { title: '用户登录', hidden: true }
//     // },
//     {
//       path: '/register',
//       component: () => import(/* webpackChunkName: "register" */ '@/views/register/index.vue'),
//       meta: { title: '用户注册', hidden: true }
//     },
//     {
//       path: '/404',
//       component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
//       meta: { hidden: true }
//     },
//     {
//       path: '/online/ceshi/:id',
//       component: () => import('@/views/online/ceshi.vue'),
//       meta: { title: '订单支付', icon: 'nested' }
//     },
//     {
//       path: '/online/fail/:id',
//       component: () => import('@/views/online/fail.vue'),
//       meta: { title: '支付失败', icon: 'nested' }
//     },
//     {
//       path: '/online/paysuccess/:id',
//       component: () => import('@/views/online/paySuccess.vue'),
//       meta: { title: '支付成功', icon: 'nested' }
//     },
//     {
//       path: '/',
//       component: Layout,
//       redirect: '/dashboard',
//       children: [
//         {
//           path: '/register/edit',
//           component: () => import(/* webpackChunkName: "dashboard" */ '@/views/register/edit.vue'),
//           meta: {
//             title: '注册资料修改',
//             icon: 'el-icon-user-solid'
//           }
//         }
//       ]
//     },
//     {
//       path: '/',
//       component: Layout,
//       redirect: '/dashboard',
//       children: [
//         {
//           path: 'dashboard',
//           component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
//           meta: {
//             title: 'Dashboard',
//             icon: 'dashboard'
//           }
//         }
//       ]
//     },
//     {
//       path: '/holdBox',
//       component: Layout,
//       redirect: '/holdBoxList/list',
//       meta: {
//         title: '押箱管理',
//         icon: 'userinfo'
//       },
//       children: [
//         {
//           path: '/holdBoxList/list',
//           component: () => import('@/views/holdBox/holdBoxList/list.vue'),
//           meta: { title: '押箱管理' }
//         },
//         // {
//         //   path: '/holdBoxListCustomer/list',
//         //   component: () => import('@/views/holdBox/holdBoxListCustomer/list.vue'),
//         //   meta: { title: '在线押箱' }
//         // },
//         // {
//         //   path: '/holdBoxList/edit',
//         //   component: () => import('@/views/holdBox/holdBoxList/edit.vue'),
//         //   meta: { title: '押箱操作' }
//         // },
//         {
//           path: '/holdBoxList/edit/:id(\\d+)',
//           component: () => import('@/views/holdBox/holdBoxList/edit.vue'),
//           meta: { title: '押箱操作', hidden: true }
//         },
//         // {
//         //   path: '/accept/list',
//         //   component: () => import('@/views/accept/list.vue'),
//         //   meta: { title: '押箱受理' }
//         // },
//         {
//           path: '/holdBoxList/manifest',
//           component: () => import('@/views/holdBox/holdBoxList/manifest.vue'),
//           meta: { title: '舱单列表' }
//         },
//         {
//           path: '/charging/list/:id(\\d+)',
//           component: () => import('@/views/holdBox/charging/list.vue'),
//           meta: { title: '计费受理单', hidden: true }
//         },
//         {
//           path: '/depositslip/list/:id(\\d+)',
//           component: () => import('@/views/holdBox/depositslip/list.vue'),
//           meta: { title: '计费受理单', hidden: true }
//         }
//         // {
//         //   path: '/subscribe/list',
//         //   component: () => import('@/views/holdBox/subscribe/list.vue'),
//         //   meta: { title: '预约押箱' }
//         // },
//         // {
//         //   path: '/subscribe/list',
//         //   component: () => import('@/views/holdBox/subscribe/list.vue'),
//         //   meta: { title: '单票查询' }
//         // },
//         // {
//         //   path: '/valuation/list',
//         //   component: () => import('@/views/holdBox/valuation/list.vue'),
//         //   meta: { title: '计价押箱单' }
//         // }
//       ]
//     },
//     {
//       path: '/online',
//       component: Layout,
//       redirect: '/online/list',
//       meta: {
//         title: '在线押箱',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/online/list',
//           component: () => import('@/views/online/list.vue'),
//           meta: { title: '在线押箱', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/personalcenter',
//       component: Layout,
//       redirect: '/personalcenter/list',
//       meta: {
//         title: '个人设置',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/personalcenter/list',
//           component: () => import('@/views/personalcenter/list.vue'),
//           meta: { title: '个人设置', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/business',
//       component: Layout,
//       redirect: '/business/list',
//       meta: {
//         title: '企业管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/business/list',
//           component: () => import('@/views/business/list.vue'),
//           meta: { title: '企业管理', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/datamanagement',
//       component: Layout,
//       redirect: '/datamanagement/list',
//       meta: {
//         title: '资料管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/datamanagement/list',
//           component: () => import('@/views/datamanagement/list.vue'),
//           meta: { title: '资料管理', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/review',
//       component: Layout,
//       redirect: '/review/list',
//       meta: {
//         title: '财务复核模块',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/review/list',
//           component: () => import('@/views/review/list.vue'),
//           meta: { title: '财务复核模块', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/retreat',
//       component: Layout,
//       redirect: '/retreat/list',
//       meta: {
//         title: '退押管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/retreat/list',
//           component: () => import('@/views/holdBox/retreat/list.vue'),
//           meta: { title: '退押管理', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/valuation',
//       component: Layout,
//       redirect: '/valuation/list',
//       meta: {
//         title: '计费管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/valuation/list',
//           component: () => import('@/views/holdBox/valuation/list.vue'),
//           meta: { title: '计费统计', icon: 'nested' }
//         },
//         {
//           path: '/valuation/audit',
//           component: () => import('@/views/holdBox/valuation/audit.vue'),
//           meta: { title: '发票审核', icon: 'nested' }
//         },
//         {
//           path: '/invoice/edit/:id(\\d+)',
//           component: () => import('@/views/basicData/invoice/edit.vue'),
//           meta: {
//             title: '编辑发票',
//             hidden: true
//           }
//         },
//         {
//           path: '/remittance/list',
//           component: () => import('@/views/remittance/list.vue'),
//           meta: {
//             title: '汇款记录',
//             hidden: true
//           }
//         },
//         {
//           path: '/transferrecord/list',
//           component: () => import('@/views/transferrecord/list.vue'),
//           meta: {
//             title: '转账记录',
//             hidden: true
//           }
//         }
//       ]
//     },
//     {
//       path: '/valuationCustomer',
//       component: Layout,
//       redirect: '/valuationCustomer/list',
//       meta: {
//         title: '线上计费管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/valuationCustomer/list',
//           component: () => import('@/views/holdBox/valuationCustomer/list.vue'),
//           meta: { title: '线上计费管理', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/money',
//       component: Layout,
//       redirect: '/money/list',
//       meta: {
//         title: '财务管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: 'invoice/list',
//           component: () => import('@/views/basicData/invoice/list.vue'),
//           meta: { title: '发票管理', icon: 'nested' }
//         },
//         {
//           path: '/invoice/query',
//           component: () => import('@/views/basicData/invoice/query.vue'),
//           meta: { title: '发票查询', icon: 'nested' }
//         },
//         {
//           path: '/invoice/redquery',
//           component: () => import('@/views/basicData/invoice/redquery.vue'),
//           meta: { title: '红票查询', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/basicData',
//       component: Layout,
//       redirect: '/customer/list',
//       meta: {
//         title: '基础资料',
//         icon: 'form'
//       },
//       children: [
//         {
//           path: '/customer/list',
//           component: () => import('@/views/basicData/customer/list.vue'),
//           meta: { title: '客商管理' }
//         },
//         {
//           path: '/fee/list',
//           component: () => import('@/views/basicData/fee/list.vue'),
//           meta: { title: '费用资料' }
//         },
//         {
//           path: '/cntr/list',
//           component: () => import('@/views/basicData/cntr/list.vue'),
//           meta: { title: '箱型资料' }
//         },
//         {
//           path: '/carrierVoy/list',
//           component: () => import('@/views/basicData/carrierVoy/index.vue'),
//           meta: { title: '航线免押管理' }
//         },
//         {
//           path: '/station/list',
//           component: () => import('@/views/basicData/station/list.vue'),
//           meta: { title: '场站资料' }
//         },
//         {
//           path: '/carrier/list',
//           component: () => import('@/views/basicData/carrier/list.vue'),
//           meta: { title: '箱属公司' }
//         },
//         {
//           path: '/deposit/list',
//           component: () => import('@/views/basicData/deposit/list.vue'),
//           meta: { title: '押金价格' }
//         },
//         {
//           path: '/invoiceCorp/list',
//           component: () => import('@/views/basicData/invoiceCorp/list.vue'),
//           meta: { title: '发票客户资料' }
//         },
//         {
//           path: '/invoiceCorp/edit/:id(\\d+)',
//           component: () => import('@/views/basicData/invoiceCorp/edit.vue'),
//           meta: { title: '编辑发票客户资料' }
//         },
//         {
//           path: '/customer/edit/:id(\\d+)',
//           component: () => import('@/views/basicData/customer/edit.vue'),
//           meta: {
//             title: '编辑客商数据',
//             hidden: true
//           }
//         },
//         {
//           path: '/customer/editType/:id(\\d+)',
//           component: () => import('@/views/basicData/customer/editType.vue'),
//           meta: {
//             title: '编辑客商分类',
//             hidden: true
//           }
//         },
//         {
//           path: '/fee/edit/:id(\\d+)',
//           component: () => import('@/views/basicData/fee/edit.vue'),
//           meta: {
//             title: '编辑费用',
//             hidden: true
//           }
//         },
//         {
//           path: '/cntr/edit/:id',
//           component: () => import('@/views/basicData/cntr/edit.vue'),
//           meta: {
//             title: '编辑箱型',
//             hidden: true
//           }
//         },
//         {
//           path: '/carrierVoy/edit/:id',
//           component: () => import('@/views/basicData/carrierVoy/edit.vue'),
//           meta: {
//             title: '编辑航线',
//             hidden: true
//           }
//         },
//         {
//           path: '/station/edit/:id',
//           component: () => import('@/views/basicData/station/edit.vue'),
//           meta: {
//             title: '编辑场站信息',
//             hidden: true
//           }
//         },
//         {
//           path: '/carrier/edit/:id',
//           component: () => import('@/views/basicData/carrier/edit.vue'),
//           meta: {
//             title: '编辑箱属公司',
//             hidden: true
//           }
//         }
//       ]
//     },
//     {
//       path: '/report',
//       component: Layout,
//       redirect: '/report/list',
//       meta: {
//         title: '报表管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/report/holdBoxReport',
//           component: () => import('@/views/report/holdBoxReport.vue'),
//           meta: { title: '线下每日押箱统计表', icon: 'nested' }
//         },
//         {
//           path: '/report/holdBoxReportonline',
//           component: () => import('@/views/report/holdBoxReportonline.vue'),
//           meta: { title: '线上每日押箱统计表', icon: 'nested' }
//         },
//         {
//           path: '/report/retreathBoxReport',
//           component: () => import('@/views/report/retreathBoxReport.vue'),
//           meta: { title: '线下每日退押箱统计表', icon: 'nested' }
//         },
//         {
//           path: '/report/retreathBoxReportonline',
//           component: () => import('@/views/report/retreathBoxReportonline.vue'),
//           meta: { title: '线上每日退押箱统计表', icon: 'nested' }
//         },
//         {
//           path: '/report/notretreatBoxReport',
//           component: () => import('@/views/report/notretreatBoxReport.vue'),
//           meta: { title: '未退押统计表', icon: 'nested' }
//         },
//         {
//           path: '/report/income',
//           component: () => import('@/views/report/income.vue'),
//           meta: { title: '线下收入表', icon: 'nested' }
//         },
//         {
//           path: '/report/importincome',
//           component: () => import('@/views/report/importincome.vue'),
//           meta: { title: '进口月度收入报表', icon: 'nested' }
//         },
//         {
//           path: '/report/incomeonline',
//           component: () => import('@/views/report/incomeonline.vue'),
//           meta: { title: '线上收入表', icon: 'nested' }
//         },
//         {
//           path: '/report/invoice',
//           component: () => import('@/views/report/invoice.vue'),
//           meta: { title: '发票统计表', icon: 'nested' }
//         },
//         {
//           path: '/report/CustomerAnalysis',
//           component: () => import('@/views/report/CustomerAnalysis.vue'),
//           meta: { title: '客户数据分析', icon: 'nested' }
//         },
//         {
//           path: '/report/importcntrcount',
//           component: () => import('@/views/report/importcntrcount.vue'),
//           meta: { title: '进口箱量统计', icon: 'nested' }
//         },
//         {
//           path: '/report/agreementUpdateHistory',
//           component: () => import('@/views/report/agreementUpdateHistory.vue'),
//           meta: { title: '协议票数历史修改记录', icon: 'nested' }
//         },
//         {
//           path: '/report/dptReport',
//           component: () => import('@/views/report/dptReport.vue'),
//           meta: { title: '押箱统计', icon: 'nested' }
//         },
//       ]
//     },
//     {
//       path: '/notice',
//       component: Layout,
//       redirect: '/notice/list',
//       meta: {
//         title: '通知管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/notice/list',
//           component: () => import('@/views/notice/list.vue'),
//           meta: { title: '通知管理', icon: 'nested' }
//         }
//       ]
//     },
//     {
//       path: '/audit',
//       component: Layout,
//       redirect: '/auditCorpUser/enterprise',
//       meta: {
//         title: '审核管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/auditCorpUser/enterprise',
//           component: () => import('@/views/auditCorpUser/enterprise.vue'),
//           meta: { title: '企业用户审核' }
//         },
//         {
//           path: '/auditCorpUser/personal',
//           component: () => import('@/views/auditCorpUser/personal.vue'),
//           meta: { title: '企业个人用户审核' }
//         },
//         {
//           path: '/auditCorpUser/details/:id',
//           component: () => import('@/views/auditCorpUser/details.vue'),
//           meta: {
//             title: '审核详情',
//             hidden: true
//           }
//         },
//         {
//           path: '/auditCorpUser/limitAudit',
//           component: () => import('@/views/auditCorpUser/limitAudit.vue'),
//           meta: { title: '协议客户次数审核' }
//         }
//       ]
//     },
//     {
//       path: '/sysAdmin',
//       component: Layout,
//       redirect: '/sysUser/list',
//       meta: {
//         title: '系统设置',
//         icon: 'table'
//       },
//       children: [
//         {
//           path: '/sysUser/list',
//           component: () => import('@/views/sysAdmin/sysUser/list.vue'),
//           meta: { title: '用户列表' }
//         },
//         {
//           path: '/sysUser/edit/:id',
//           component: () => import('@/views/sysAdmin/sysUser/edit.vue'),
//           meta: {
//             title: '编辑用户',
//             hidden: true
//           }
//         },
//         {
//           path: '/sysOrganize/list',
//           component: () => import('@/views/sysAdmin/sysOrganize/list.vue'),
//           meta: { title: '组织列表' }
//         },
//         {
//           path: '/sysDictionary/list',
//           component: () => import('@/views/sysAdmin/sysDictionary/list.vue'),
//           meta: { title: '数据字典' }
//         },
//         {
//           path: '/sysDictionary/edit/:id(\\d+)',
//           component: () => import('@/views/sysAdmin/sysDictionary/edit.vue'),
//           meta: {
//             title: '编辑数据字典',
//             hidden: true
//           }
//         },
//         {
//           path: '/sysDictionary/editType/:id(\\d+)',
//           component: () => import('@/views/sysAdmin/sysDictionary/editType.vue'),
//           meta: {
//             title: '编辑字典分类',
//             hidden: true
//           }
//         },
//         {
//           path: '/sysRole/list',
//           component: () => import('@/views/sysAdmin/sysRole/list.vue'),
//           meta: { title: '角色列表' }
//         },
//         {
//           path: '/sysModule/list',
//           component: () => import('@/views/sysAdmin/sysModule/list.vue'),
//           meta: { title: '模块列表' }
//         },
//         {
//           path: '/taffiche/list',
//           component: () => import('@/views/sysAdmin/taffiche/list.vue'),
//           meta: { title: '公告列表' }
//         },
//         {
//           path: '/taffiche/edit/:id',
//           component: () => import('@/views/sysAdmin/taffiche/edit.vue'),
//           meta: {
//             title: '编辑公告',
//             hidden: true
//           }
//         }
//       ]
//     },
//     {
//       path: '/account',
//       component: Layout,
//       redirect: '/account/list',
//       meta: {
//         title: '账户管理',
//         icon: 'nested'
//       },
//       children: [
//         {
//           path: '/account/list',
//           component: () => import('@/views/account/list.vue'),
//           meta: { title: '账户管理', icon: 'example' }
//         }
//       ]
//     },
//     {
//       path: '*',
//       redirect: '/404',
//       meta: { hidden: true }
//     }
//   ]
// })
export default new Router({
  // mode: 'history',  // Enable this if you need.
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/login/client.vue'),
      meta: { title: '用户登录', hidden: true }
    },
    {
      path: '/register',
      component: () => import(/* webpackChunkName: "register" */ '@/views/register/index.vue'),
      meta: { title: '用户注册', hidden: true }
    },
    /* {
      path: '/register/enterprise',
      component: () => import( webpackChunkName: "register"  '@/views/register/userEnterprise.vue'),
      meta: { title: '用户注册', hidden: true }
    }, */
    {
      path: '/404',
      component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue'),
      meta: { hidden: true }
    },
    {
      path: '/online/ceshi/:id',
      component: () => import('@/views/online/ceshi.vue'),
      meta: { title: '订单支付', icon: 'nested' }
    },
    {
      path: '/online/fail/:id',
      component: () => import('@/views/online/fail.vue'),
      meta: { title: '支付失败', icon: 'nested' }
    },
    {
      path: '/online/paysuccess/:id',
      component: () => import('@/views/online/paySuccess.vue'),
      meta: { title: '支付成功', icon: 'nested' }
    },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        {
          path: '/register/edit',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/register/edit.vue'),
          meta: {
            title: '注册资料修改',
            icon: 'el-icon-user-solid'
          }
        }
      ]
    },
    {
      path: '/',
      component: Layout,
      redirect: '/dashboard',
      children: [
        {
          path: 'dashboard',
          component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index.vue'),
          meta: {
            title: 'Dashboard',
            icon: 'dashboard'
          }
        }
      ]
    },
    {
      path: '/holdBox',
      component: Layout,
      redirect: '/holdBoxList/list',
      meta: {
        title: '押箱管理',
        icon: 'userinfo'
      },
      children: [
        {
          path: '/holdBoxList/edit/:id(\\d+)',
          component: () => import('@/views/holdBox/holdBoxList/edit.vue'),
          meta: { title: '押箱操作', hidden: true }
        }
      ]
    },
    {
      path: '/online',
      component: Layout,
      redirect: '/online/list',
      meta: {
        title: '在线押箱',
        icon: 'nested'
      },
      children: [
        {
          path: '/online/list',
          component: () => import('@/views/online/list.vue'),
          meta: { title: '在线押箱', icon: 'nested' }
        }
      ]
    },
    {
      path: '/personalcenter',
      component: Layout,
      redirect: '/personalcenter/list',
      meta: {
        title: '个人设置',
        icon: 'nested'
      },
      children: [
        {
          path: '/personalcenter/list',
          component: () => import('@/views/personalcenter/list.vue'),
          meta: { title: '个人设置', icon: 'nested' }
        }
      ]
    },
    {
      path: '/business',
      component: Layout,
      redirect: '/business/list',
      meta: {
        title: '企业管理',
        icon: 'nested'
      },
      children: [
        {
          path: '/business/list',
          component: () => import('@/views/business/list.vue'),
          meta: { title: '企业管理', icon: 'nested' }
        }
      ]
    },
    {
      path: '/datamanagement',
      component: Layout,
      redirect: '/datamanagement/list',
      meta: {
        title: '资料管理',
        icon: 'nested'
      },
      children: [
        {
          path: '/datamanagement/list',
          component: () => import('@/views/datamanagement/list.vue'),
          meta: { title: '资料管理', icon: 'nested' }
        }
      ]
    },
    {
      path: '/valuationCustomer',
      component: Layout,
      redirect: '/valuationCustomer/list',
      meta: {
        title: '线上计费管理',
        icon: 'nested'
      },
      children: [
        {
          path: '/valuationCustomer/list',
          component: () => import('@/views/holdBox/valuationCustomer/list.vue'),
          meta: { title: '线上计费管理', icon: 'nested' }
        }
      ]
    },
    {
      path: '/audit',
      component: Layout,
      redirect: '/auditCorpUser/enterprise',
      meta: {
        title: '审核管理',
        icon: 'nested'
      },
      children: [
        {
          path: '/auditCorpUser/enterprise',
          component: () => import('@/views/auditCorpUser/enterprise.vue'),
          meta: { title: '企业用户审核' }
        },
        {
          path: '/auditCorpUser/personal',
          component: () => import('@/views/auditCorpUser/personal.vue'),
          meta: { title: '企业个人用户审核' }
        },
        {
          path: '/auditCorpUser/details/:id',
          component: () => import('@/views/auditCorpUser/details.vue'),
          meta: {
            title: '审核详情',
            hidden: true
          }
        }
      ]
    },
    {
      path: '/account',
      component: Layout,
      redirect: '/account/list',
      meta: {
        title: '账户管理',
        icon: 'nested'
      },
      children: [
        {
          path: '/account/list',
          component: () => import('@/views/account/list.vue'),
          meta: { title: '账户管理', icon: 'example' }
        }
      ]
    },
    {
      path: '*',
      redirect: '/404',
      meta: { hidden: true }
    }
  ]
})
